import {
  accesoriesDto,
  customerDto,
  dealsDto,
  models,
  quoteDto,
} from './standard-quote.model';

export class BodyCalculate {
  nameCompany: string | undefined;
  financialProduct: string;
  currency: string | undefined;
  calculationType: string;
  maturityType: string;
  quantity: number | undefined;
  unitPrice: number | undefined;
  term: number;
  taxFree: boolean;
  customerRate: number;
  confirmationExpensesAmount: number;
  lifeInsuranceFactor: number;
  lifeInsuranceAmount: number;
  insuranceAmount: number | null;
  openingFeeType: string;
  openingFeePercentage: number;
  openingFee: number;
  balloonType: string;
  balloonPercentage: number;
  balloon: number;
  gracePeriodApplyTo: string;
  gracePeriod: number;
  downPaymentTaxType: string;
  downPaymentTax: number;
  downPayment: number;
  specialPayments: any;
  grace: any;
  financialSetupId: string;
  financialConditionId: string;
  modeId: number | null;
  personType: string | undefined;
  purchasePercentage: number | null;
  residualValuePercentage: number | null;

  constructor(data: any, formData: quoteDto | null, models: models | null, customer: customerDto | null,amount: number | null = null, standardQuoteModel: models | undefined) {
    this.personType = customer?.personType;
    this.modeId = models ? models.id : null;
    this.nameCompany = formData?.companyName;
    this.financialProduct = data.financialSetup.financialProduct;
    this.currency = formData?.model.currency;
    this.calculationType = data.financialSetup.calculationType;
    this.maturityType = data.financialSetup.paymentType;
    this.quantity = formData?.quantity;
    this.unitPrice = standardQuoteModel ? standardQuoteModel.price : this.getPrice(formData);
    this.term = data.financialSetup.financialCondition.term;
    // Convertir taxFree a boolean (puede venir como string "true"/"false" o boolean)
    const taxFreeValue = data.financialSetup?.taxFree;
    this.taxFree = taxFreeValue === true || taxFreeValue === "true" || taxFreeValue === "TRUE" || false;
    this.customerRate = data.financialSetup.financialCondition.nominalRate;
    this.confirmationExpensesAmount = 3886;
    this.lifeInsuranceFactor = 0;
    if (amount != null && amount > 0) {
      this.insuranceAmount = amount;
    }
    this.insuranceAmount = amount;
    this.openingFeeType = data.financialSetup.openingFeeType;
    this.openingFeePercentage = data.financialSetup.openingFeeTax;
    this.openingFee = data.financialSetup.openingFee;
    this.balloonType = data.financialSetup.balloonType;
    this.balloonPercentage = data.financialSetup.balloonPercentage;
    this.balloon = data.financialSetup.balloon;
    this.gracePeriodApplyTo = 'CAPITAL';
    this.gracePeriod = 1;
    this.downPaymentTaxType = data.financialSetup.downPaymentTaxType;
    this.downPaymentTax = data.financialSetup.downPaymentTax;
    this.downPayment = data.financialSetup.downPayment;
    this.specialPayments = data.specialPayments;
    this.grace = data.grace;
    this.financialSetupId = data.financialSetup.id;
    this.financialConditionId = data.financialSetup.financialCondition.id;
    this.purchasePercentage = data.financialCondition.purchasePercentage;
    this.residualValuePercentage = data.financialSetup.externalWarrantyRate;
  }

  getPrice(formData: quoteDto | null) {
    let price = 0;
    if (formData?.model) {
      price = formData.model.price;
      if (formData.accessories) {
        formData.accessories.map((i) => (price += i.price));
      }
    }
    return price;
  }
}

export class BodySave {
  id: number;
  creationDate?: string;
  creationUser?: number;
  customer: customerDto;
  customerId: number;
  model: models;
  standardQuoteDeals: dealsDto[];
  accessories: accesoriesDto[];
  dealAmount: number;
  status: string;
  updateUser?: number;
  updatedDate?: string;
  companyName: string;
  quoteName: string;
  dealerId: number;
  quantity: number;
  wholeSaleId: number

  constructor(data: any) {
    this.id = data.id;
    // Include all customer fields, not just personType
    const customerDto: any = {
      ...data.customer
    }
    this.customer = customerDto;
    this.customerId = data.customerId;
    this.model = data.model;
    this.standardQuoteDeals = data.standardQuoteDeals.map(
      (i: any) => new Deal(i)
    );
    this.accessories = data.accessories;
    this.dealAmount = data.dealAmount;
    this.status = data.status;
    this.companyName = data.companyName;
    this.quoteName = data.quoteName;
    this.dealerId = data.dealer ? data.dealer.id : data.dealerId;
    this.quantity = data.quantity;
    this.wholeSaleId = data.wholeSale ? data.wholeSale.id : data.wholeSaleId;
    if (data.id) {
      this.creationDate = data.creationDate;
      this.updatedDate = data.updatedDate;
      this.creationUser = data.creationUser;
      this.updateUser = data.updateUser;
      if (data.standardQuoteModel)
        this.model.price = data.standardQuoteModel?.price;
    }
  }
}

export class Deal {
  id: number;
  creationDate?: string;
  creationUser?: number;
  updateUser?: number;
  updatedDate?: string;
  financialSetupName: string;
  financialProduct: string;
  currency: string;
  classification: boolean;
  calendarType: string;
  paymentFormationType: string;
  allowPaymentDay: boolean;
  allowCapitalGrace: boolean;
  allowInterestGrace: boolean;
  allowOpeningFee: boolean;
  openingFeeType: string;
  purchaseOptionType: string;
  warrantyDeposit: string;
  companyName: string;
  financialSetupDescription: string;
  paymentType: string;
  downPaymentTaxType: string;
  openingFee: number;
  openingFeeTax: number;
  downPayment: number;
  downPaymentTax: number;
  isSelected: boolean;
  financialCondition: any;
  financialSetup: any;
  payments: any;
  result: any;
  standardFinancialSetup: any;
  standardQuoteCondition: any;
  specialPayments: any;
  grace: any;
  insurance: any;

  constructor(data: any) {
    this.id = data.id;
    this.financialSetupName = data.financialSetupName;
    this.financialProduct = data.financialProduct;
    this.currency = data.currency;
    this.classification = data.classification;
    this.calendarType = data.calendarType;
    this.paymentFormationType = data.paymentFormationType;
    this.allowPaymentDay = data.allowPaymentDay;
    this.allowCapitalGrace = data.allowCapitalGrace;
    this.allowInterestGrace = data.allowInterestGrace;
    this.allowOpeningFee = data.allowOpeningFee;
    this.openingFeeType = data.openingFeeType;
    this.purchaseOptionType = data.purchaseOptionType;
    this.warrantyDeposit = data.warrantyDeposit;
    this.companyName = data.companyName;
    this.financialSetupDescription = data.financialSetupDescription;
    this.paymentType = data.paymentType;
    this.downPaymentTaxType = data.downPaymentTaxType ?? data.financialSetup?.downPaymentTaxType ?? data.standardFinancialSetup?.downPaymentTaxType;
    this.openingFee = data.openingFee ?? data.financialSetup?.openingFee ?? data.standardFinancialSetup?.openingFee;
    this.openingFeeTax = data.openingFeeTax ?? data.financialSetup?.openingFeeTax ?? data.standardFinancialSetup?.openingFeeTax;
    this.downPayment = data.downPayment ?? data.financialSetup?.downPayment ?? data.standardFinancialSetup?.downPayment;
    this.downPaymentTax = data.downPaymentTax ?? data.financialSetup?.downPaymentTax ?? data.standardFinancialSetup?.downPaymentTax;
    this.isSelected = data.isSelected;
    this.financialCondition = data.financialCondition;
    this.financialSetup = data.financialSetup ? {
      ...data.financialSetup,
      downPayment: this.downPayment,
      downPaymentTax: this.downPaymentTax,
      downPaymentTaxType: this.downPaymentTaxType,
      openingFee: this.openingFee,
      openingFeeTax: this.openingFeeTax,
    } : data.financialSetup;
    this.payments = data.payments;
    this.specialPayments = data.specialPayments;
    this.grace = data.grace;
    this.insurance = this.verifyInsurance(data.insurance);
    this.result = data.result;
    this.standardFinancialSetup = data.standardFinancialSetup;
    this.standardQuoteCondition = data.standardQuoteCondition;
    if (data.id) {
      this.creationDate = data.creationDate;
      this.updatedDate = data.updatedDate;
      this.creationUser = data.creationUser;
      this.updateUser = data.updateUser;
    }
  }

  private verifyInsurance(insurance: any) {
    if (!insurance) {
      return null;
    }
    const allowedKeys = new Set(["vehicleServiceType", "financialProductType"]);

    // Verifico si algún campo fuera de los permitidos tiene un valor no nulo
    const hasOtherValues = Object.entries(insurance).some(([key, value]) => {
      if (allowedKeys.has(key)) return false;
      return value !== null && value !== undefined;
    });
    if (!hasOtherValues) return null;

    return insurance;
  }
}
